export function formatDouble(value, fractLength = 5) {

    if (!value) {
        return null;
    }

    let strValue = value.toString();
    let dotPos = strValue.indexOf(".");
    let valueParts = strValue.split(".");

    if (dotPos === -1 || valueParts.length < 2) {
        return value;
    }

    return valueParts[0] + "." + valueParts[1].slice(dotPos, fractLength);
}

export function formatDate(dt) {
    return dt.getFullYear() + '-' +
        ('0' + (dt.getMonth() + 1)).slice(-2) + '-' +
        ('0' + dt.getDate()).slice(-2) + ' ' +
        ('0' + dt.getHours()).slice(-2) + ':' +
        ('0' + dt.getMinutes()).slice(-2) + ':' +
        ('0' + dt.getSeconds()).slice(-2)
}


export function getViewport() {
    const width = Math.max(
        document.documentElement.clientWidth,
        window.innerWidth || 0
    );

    if (width <= 576) return 'xs'
    if (width <= 768) return 'sm'
    if (width <= 992) return 'md'
    if (width <= 1200) return 'lg'
    return 'xl'
}

export function getIsViewportEqual(viewports) {
    return viewports.indexOf(getViewport()) !== -1;
}

export function getCheckpointNiceName(checkpoint) {
    return `${checkpoint.name} - ${checkpoint.description}`;
}

export function getClientVersion() {
    return {
        app: process.env.REACT_APP_VERSION,
        // git: process.env.REACT_APP_GIT_VERSION,
        git: `${process.env.REACT_APP_GIT_VERSION.slice(0, 4)}${process.env.REACT_APP_GIT_VERSION.slice(-4)}`,
    };
}
